import { render, staticRenderFns } from "./PuzzleActions.vue?vue&type=template&id=39efab4b"
import script from "./PuzzleActions.vue?vue&type=script&lang=js"
export * from "./PuzzleActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports